import * as React from "react";
const SvgMoreWhite = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M10 12.8a.8.8 0 0 1 .8-.8h18.4a.8.8 0 0 1 0 1.6H10.8a.8.8 0 0 1-.8-.8m0 14.536a.8.8 0 0 1 .8-.8h18.4a.8.8 0 0 1 0 1.6H10.8a.8.8 0 0 1-.8-.8m20-7.268a.8.8 0 0 0-.8-.8H10.8a.8.8 0 1 0 0 1.6h18.4a.8.8 0 0 0 .8-.8"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMoreWhite;
